import {Localizer} from "../../../../infrastructure/localization/localizer";
import PdfHeaderRow from "../components/pdfHeaderRow";
import { UserProfileModel } from "../../userProfile/userProfileModel";

export function PdfDetailedUserHeaderComponent({ bruger }: { bruger: UserProfileModel }) {
    return (
        <>
            <PdfHeaderRow>
                <PdfHeaderRow.Entry
                    label={Localizer.global_name()}
                    value={bruger.getFullName()}
                />
                <PdfHeaderRow.Entry
                    label={Localizer.global_foedselsdato()}
                    value={bruger.foedselsdato}
                />
            </PdfHeaderRow>
            <PdfHeaderRow>
                <PdfHeaderRow.Entry
                    label={Localizer.global_mobilePhone()}
                    value={bruger.phone}
                />
                <PdfHeaderRow.Entry
                    label={Localizer.global_email()}
                    value={bruger.email}
                />
            </PdfHeaderRow>
            <PdfHeaderRow>
                <PdfHeaderRow.Entry
                    label={Localizer.global_authorisationId()}
                    value={bruger.authorizationId}
                />
            </PdfHeaderRow>
        </>
    );
}
